import 'mapbox.js/dist/mapbox.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';

import 'mapbox.js';
import 'leaflet.markercluster';

import Group from './group/_group';

const $ = jQuery;

L.mapbox.accessToken = 'pk.eyJ1IjoiZGlnaXRhbGFkbWluIiwiYSI6ImNpbXdsb2dqaDAzOHB2bG00c2o3aWdyMmgifQ.hEQS_8NE5RBINFupdHhdSA';

/*
 This wraps a Mapbox map object
 Handles any of the business logic required for all components to
 interact with the map
 */
export default class Map {
    constructor(tileset, featureLayer = '_default') {
        this.markers = {};
        this.layers = {
            tileset,
        };

        this._markers = [];
        this._featureLayer = featureLayer;
        this._bounds = L.latLngBounds([]);
    }

    // Initialize the Mapbox map
    init(map, position = [37.0902, -95.7129], zoomLevel = 4) {
        this.map = L.mapbox.map(map, undefined, {
            minZoom: Map.isMobile() ? 2 : 3,
            maxZoom: 12,
            zoomControl: false,
            attributionControl: false,
            worldCopyJump: true,
            maxBoundsViscosity: 1.0,
            tapTolerance: 50,
        });

        $.each(this.layers, (name, layer) => {
            layer.addTo(this.map);
        });
        
        this.map.setView(position, zoomLevel);
    }

    // Load all markers via API GeoJSON endpoint
    // Takes an optional object with 'feature' and 'complete' custom callbacks
    load(url, cb = {}) {
        this.feature = L.mapbox.featureLayer().loadURL(url).on('ready', () => {
            // Iterate through every marker layer defined in GeoJSON Response
            this.feature.eachLayer((marker) => {
                // Find the group the marker belongs to...
                const targetGroup = this.matchMarkerToGroup(marker);
                targetGroup.addMarker(marker); // Add the marker
                this._markers.push(marker.feature); // Track the marker layer
                this._bounds.extend(marker.getLatLng()); // Extend the known boundaries
                if (typeof cb.feature === 'function') {
                    cb.feature(marker); // Execute custom callback for each feature
                }
            });
            if (typeof cb.complete === 'function') {
                cb.complete(this._markers); // Execute custom callback on completion
            }
        });

        // Add all marker groups to map once finished
        $.each(this.markers, (name, group) => {
            group.getLayer().addTo(this.map);
        });
    }

    // WOOSH
    // Optionally animate the map to fit all markers within the calculated boundaries
    fitBounds(bounds = this._bounds, animate = true) {
        this.map[animate ? 'flyToBounds' : 'fitBounds'](bounds);
    }

    // Add and track a marker layer by name
    // Called by group.vue on registration of a new group component
    addMarkerGroup(group) {
        this.markers[group.name] = group;
    }

    // Returns the group that a marker matches
    matchMarkerToGroup(marker) {
        let match = false;
        $.each(this.markers, (name, group) => {
            if (group.isMatch(marker)) {
                match = group;
                return false; // Break out of the jQuery loop
            }
        });
        return match || this.markers[this._featureLayer];
    }

    // Simple show / hide toggle - Turns group layer on or off
    // Called by filters.vue when clicking a checkbox
    filterLayer(name, show) {
        this.map[`${show ? 'add' : 'remove'}Layer`](this.markers[name].getLayer());
    }

    // We aren't using this quite yet, but we might need to later....
    static isMobile() {
        return $(window).width() < 992;
    }
}



// WEBPACK FOOTER //
// ./Assets/Scripts/Components/Mapbox/_mapbox.js